import React, { useEffect } from 'react'
import arrowIcon from '../assets/arrow-theme.png'
import about from '../assets/ep_about_img.webp'

import { a } from '../ss'
// import MoveEle from './MoveEle'



export default function HomeAbout() {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.13.0/gsap.min.js';
        script.async = true; // or script.defer = true; for deferred loading

        const script1 = document.createElement('script');
        script1.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.13.0/ScrollTrigger.min.js';
        script1.async = true;


        script.onload = () => {
            a()


        };
        document.body.appendChild(script);
        document.body.appendChild(script1);
        return () => {
            // Clean up: remove the script when the component unmounts
            document.body.removeChild(script);
            document.body.removeChild(script1);
        };
    }, [])
    return (
        <>
            <div className='about-wrap container pt-5 mb-4'>
                {/* <MoveEle/>                */}
                <div className='row pt-5 pb-5 d-flex align-content-center'>
                    <div className='col-lg-5 me-auto mb-lg-0 thum-about-order'>
                        <div className='thumb-style-four'>
                            <img src={about} alt='Your SnapRupee  Loan Partner' className='img-fluid' />
                        </div>
                    </div>

                    <div className='col-lg-7 align-content-center'>
                        <div className='d-flex '>
                            <div className='ms-arrow-icon'>
                                <img src={arrowIcon} alt="SnapRupee " className='img-fluid' />
                            </div>
                            <div className='m-4'>
                                <p className='tag'>Discover SnapRupee </p>
                                <h2 className='main-heading'>Your SnapRupee  Loan Partner</h2>
                            </div>
                        </div>
                        <p style={{ lineHeight: '30px' }}> 
                            SnapRupee is the digital lending platform of Surya Jyoti Leasing and Finance Limited, a Non-Banking Financial Company (NBFC).

                            The platform is designed to provide customers with a convenient digital experience for exploring and applying for loan products offered by the company. Through a technology-enabled application process, customers can access product information, submit applications, upload documents, and track application status online.

                            Surya Jyoti Leasing and Finance Limited is committed to responsible lending practices, transparent communication, customer-centric service, and compliance with applicable regulatory requirements.

                            Loan approvals, loan amounts, interest rates, tenure, and disbursal timelines are subject to customer eligibility, verification, and internal credit assessment policies.
                        </p>

                    </div>

                </div>
            </div>

        </>
    )
}
